import React from "react";

// Vive en su propio archivo para que las dos pestañas de Performance lo usen sin que
// una tenga que importar de la otra.
const KpiCard = ({ titulo, valor, color, sufijo, detalle }) => (
    <div
        style={{
            backgroundColor: "white",
            padding: 15,
            borderRadius: 5,
            boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            minHeight: 90,
        }}
    >
        <p style={{ margin: 0, color: "#666", fontSize: 12 }}>{titulo}</p>
        <p style={{ margin: 0, color: color || "#00BFD6", fontSize: 22, fontWeight: "bold" }}>
            {valor}
            {sufijo ? <span style={{ fontSize: 14, marginLeft: 4 }}>{sufijo}</span> : null}
        </p>
        {detalle ? (
            <p
                style={{
                    margin: 0,
                    color: "#999",
                    fontSize: 11,
                    fontFamily: "monospace",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                title={detalle}
            >
                {detalle}
            </p>
        ) : null}
    </div>
);

export default KpiCard;
